import feliciaPic from "@/public/images/artists/felicia.png";
import { Artist } from "@/types/types";

export const felicia = {
  id: "216",
  name: "Felicia",
  image: feliciaPic,
  description: `Felicia is your go-to singer for emotional dance and pop tracks. She has an airy tone and a high vocal range, handling falsetto with ease.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffelicia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Pop",
        "Dance",
        "RnB",
        "Falsetto",
        "Unprocessed",
        "Airy",
        "Indie",
        "Folk",
        "Jazz",
        "Ethereal",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 58,
        high: 73,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
